import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_CONFIG } from '../shared/constants/api';
import { useTranslation } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../logo.svg';
import './Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_CONFIG.BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess(true);
      } else {
        setError(data.error || t('common.networkError'));
      }
    } catch {
      setError(t('common.networkError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-language-switcher">
        <LanguageSwitcher />
      </div>
      <div className="auth-box">
        <img src={logo} alt="Monnaify Logo" className="auth-logo" />
        <h1>{t('auth.forgotPassword.title')}</h1>
        <p className="auth-subtitle">{t('auth.forgotPassword.subtitle')}</p>

        {success ? (
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✉️</div>
            <p style={{ color: '#444', lineHeight: 1.6 }}>{t('auth.forgotPassword.successMessage')}</p>
            <div className="auth-link" style={{ marginTop: 24 }}>
              <Link to="/login">{t('auth.forgotPassword.backToLogin')}</Link>
            </div>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">{t('auth.forgotPassword.email')}</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder={t('auth.forgotPassword.emailPlaceholder')}
                  disabled={loading}
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? t('auth.forgotPassword.loading') : t('auth.forgotPassword.submit')}
              </button>
            </form>
            <div className="auth-link">
              <Link to="/login">{t('auth.forgotPassword.backToLogin')}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
